import React from 'react';

const MapGeofence = ({ svgRef, title, ...props }) => (
    <svg xmlnsXlink="http://www.w3.org/1999/xlink" 
      width="1em"
      height="1em"
      viewBox="0 0 60 50"
      ref={svgRef}
      {...props}
    >
      <title>{title}</title>
      <image
        data-name="Livello 0"
        width={60}
        height={50}
        xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAyCAMAAAA3KEgwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAQlBMVEUAAABKxr9Jxr5Jxr5Jxr9Jx75Jxr5Jxr531M7S8e/////R8e/d9PNgzcZUysKO29b0/Pvp+Pek49+76udr0coAAACrL/t/AAAAB3RSTlMATMTvUMfw6s2iHwAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkAhsHNglJVk+eAAAAqklEQVRIx+3WSQ7DIBBE0fZYDMZO7Nz/rDEQlhBRrBLRaonV05dYtcgwTiBmGgeRmZFxZll4vMjK41V4C3Tc8a9iFZbEOiyHlQGMIrH22HJYGY9L6QLWEVsG3+GAC+k81gnbeuzDG7CV0lnsww5wpXQW++Qesa7Gh086Z+/nqP+wh/nMs/7DcCZ8EtglvBMYV7QXGKwiflH4+3Tc8d/ipvOx6XBtOplbjvU3FuFTZTjHk/oAAAAASUVORK5CYII="
      />
    </svg>
);

export default MapGeofence;



// WEBPACK FOOTER //
// ./src/common/icons/MapGeofence.js